import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { theAviyanaDropdown } from "./NavItems";
import "./Dropdown.css";
import Navbar from "./Navbar";

function CastleDropdown(props) {
  const [dropdown, setDropdown] = useState(false); // create stute

  const redirectToPage = (a) => {
    window.location = a;
  };

  return (
    <>
      <div className="navigation-sub-title-sec">
        <div className="navigation-sub-nav-bar ">
          <div className="navigation-sub-nav-part col">
            <div className="subNav-part-sec1">
              <ul className="sub-title-list">
                <div className="subnav-header-sec">
                  <li>
                    <p
                      className="subNavHeader"
                      onClick={() => redirectToPage("/")}
                    >
                      - Our Concept, Present & Future
                    </p>
                  </li>
                </div>
                {theAviyanaDropdown.map((item) => {
                  if (item.id < 10) {
                    return (
                      <div className="subnav-list-item">
                        <li key={item.id}>
                          {/* <Link
                            to={item.path}
                            className="submenu-item1 "
                            onClick={() => redirectToPage(item.path)}
                          >
                            {item.title}
                          </Link> */}

                          <HashLink
                            onClick={() => redirectToPage(item.path)}
                            className="submenu-item1"
                          >
                            {item.title}
                          </HashLink>
                        </li>
                      </div>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
          <div className="navigation-sub-nav-part col">
            <div className="subNav-part-sec1">
              <ul className="sub-title-list">
                <div className="subnav-header-sec">
                  <li>
                    <p
                      className="subNavHeader"
                      onClick={() => redirectToPage("/location")}
                    >
                      - Plan with us
                    </p>
                  </li>
                </div>
                {theAviyanaDropdown.map((item) => {
                  if (item.id > 9 && item.id < 19) {
                    return (
                      <div className="subnav-list-item">
                        <li key={item.id}>
                          {/* <Link
                            to={item.path}
                            className="submenu-item1"
                            onClick={() => redirectToPage(item.path)}
                          >
                            {item.title}
                          </Link> */}

                          <HashLink
                            onClick={() => redirectToPage(item.path)}
                            className="submenu-item1"
                          >
                            {item.title}
                          </HashLink>
                        </li>
                      </div>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
          <div className="navigation-sub-nav-part col">
            <div className="subNav-part-sec1">
              <ul className="sub-title-list">
                <div className="subnav-header-sec">
                  <li>
                    <p
                      className="subNavHeader"
                      onClick={() => redirectToPage("/SpecialService")}
                    >
                      - Special Service
                    </p>
                  </li>
                </div>
                {theAviyanaDropdown.map((item) => {
                  if (item.id > 18) {
                    return (
                      <div className="subnav-list-item">
                        <li key={item.id}>
                          {/* <Link
                            to={item.path}
                            className="submenu-item1"
                            onClick={() => redirectToPage(item.path)}
                          >
                            {item.title}
                          </Link> */}

                          <HashLink
                            to={item.path}
                            // onClick={() => redirectToPage(item.path)}
                            className="submenu-item1"
                          >
                            {item.title}
                          </HashLink>
                        </li>
                      </div>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CastleDropdown;
